<template>
  <div id="app">
      <link href='https://fonts.googleapis.com/css?family=Poiret One' rel='stylesheet'>
      <link href='https://fonts.googleapis.com/css?family=Amaranth' rel='stylesheet'>
      <link href='https://fonts.googleapis.com/css?family=Jura' rel='stylesheet'>

    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand p-0" href="#">
            <div class="shadow">
                <img src=".\assets\testIcon2.png" class="rounded" width="90" style="opacity: .7">
            </div>
        </a>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div class="navbar-nav">
                <a class="nav-item nav-link active" href="#">
                    Home <span class="sr-only">(current)</span>
                </a>
            </div>
        </div>
    </nav>


    <div class="container-fluid mt-2">
        <div class="row mb-0">
            <div class="col">
            </div>       
            <!--_____________________________________________________-->
            <div class="col-md-6">
                <div class="card bg-light text-center h-100">
                    <h1 class="card-header bg-dark" v-bind:style = "{color: activeColor}">{{currentJpnChar}}</h1>
                    <div class="card-body container">
                        <div class="card-text row">
                            <div class="col"></div>
                            <div class="col">
                                <div class="input-group input-group-lg mb-3" style="min-width: 150px">
                                    <div v-if="autoFirstLetter" class="input-group-prepend ">
                                        <span class="input-group-text bg-dark">{{currentFirstLetter}}</span>
                                    </div>
                                    <input v-model="userIn" v-on:keyup.enter="enterHit" ref="testo" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="button-addon2">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-primary" type="button" id="button-addon2" v-on:click="enterHit()">Next</button>
                                    </div>
                                    
                                    
                                </div>
                                <div v-if="(oneSelected)">
                                <input id="cboxBtns" type="checkbox" v-model="showButtons">
                                <label class="form-check-label" for="cboxBtns" style="font-size: 24px">Quick Buttons</label>
                                </div>
                                
                            </div>
                            <div class="col">

                            </div>

                        </div>
                        <div class="row">
                            <div class="col"></div>
                            <div class="col-auto">
                                <div v-if="(oneSelected && !cboxes[9].enabled && !showButtons)">
                                    <input id="cboxAuto" type="checkbox" v-model="autoFirstLetter">
                                    <label class="form-check-label" for="cboxAuto" style="font-size: 24px">Auto-include first letter</label>
                                </div>
                            </div>
                            <div class="col">
                                
                            </div>
                        </div>   
                        <div class="row">
                            <div class="col">
                                <div v-if="showButtons">
                                    <div class="btn-group" role="group">
                                        <button v-for="btn in buttonChars" type="button" class="btn btn-primary btn-lg" v-on:click="autoButtons(btn)">{{btn}}</button>
                                    </div>

                                </div>
                            </div>
                        </div>                     
                    </div>
                </div>
             </div>
            <!--_____________________________________________________-->
            <div class="col ">
                
                
            </div>
        </div>

<!--_____________________________________________________-->
        <div class="row"> <!-- row2 -->
            <div class="col"></div>
            

            <div class="col-md-6">
                <div class="card bg-light"> 
                    <h1 class="card-header bg-dark"><button class="btn btn-primary btn-block" v-on:click="showChart = !showChart">Chart</button></h1>
                    <div class="card-body bg-light pb-0" v-if="showChart">
                        <div class="packInside">
                            <my-table></my-table>
                        </div>
                    </div>    
                </div>
            </div>

            <div class="col"></div>
        </div>
<!--_____________________________________________________-->
        <div class="row">
            <div class="col">

            </div>
            <!--_____________________________________________________-->
            <div class="col-md-6">
                <div class="card bg-light">
                    <h1 class="card-header bg-dark">Categories</h1>
                    <div class="container card-body">
                        <div class="row card-text">
                            <div class="col-auto"><input type="checkbox" id="cboxK" v-model="cboxes[0].enabled"> <label for="cboxK">K</label></div>            
                            <div class="col-auto"><input type="checkbox" id="cboxS" v-model="cboxes[1].enabled"> <label for="cboxS">S</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxT" v-model="cboxes[2].enabled"> <label for="cboxT">T</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxN" v-model="cboxes[3].enabled"> <label for="cboxN">N</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxH" v-model="cboxes[4].enabled"> <label for="cboxH">H</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxM" v-model="cboxes[5].enabled"> <label for="cboxM">M</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxY" v-model="cboxes[6].enabled"> <label for="cboxY">Y</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxR" v-model="cboxes[7].enabled"> <label for="cboxR">R</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxW" v-model="cboxes[8].enabled"> <label for="cboxW">W</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxV" v-model="cboxes[9].enabled"> <label for="cboxV">Vowels</label></div>
                        </div> 
                        <div class="row card-text">
                            <div class="col-auto"><input type="checkbox" id="cboxKK" v-model="cboxes[10].enabled"> <label for="cboxKK">K</label></div>            
                            <div class="col-auto"><input type="checkbox" id="cboxKS" v-model="cboxes[11].enabled"> <label for="cboxKS">S</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxKT" v-model="cboxes[12].enabled"> <label for="cboxKT">T</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxKN" v-model="cboxes[13].enabled"> <label for="cboxKN">N</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxKH" v-model="cboxes[14].enabled"> <label for="cboxKH">H</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxKM" v-model="cboxes[15].enabled"> <label for="cboxKM">M</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxKY" v-model="cboxes[16].enabled"> <label for="cboxKY">Y</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxKR" v-model="cboxes[17].enabled"> <label for="cboxKR">R</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxKW" v-model="cboxes[18].enabled"> <label for="cboxKW">W</label></div>
                            <div class="col-auto"><input type="checkbox" id="cboxKV" v-model="cboxes[19].enabled"> <label for="cboxKV">Vowels</label></div>
                            <div class="btn-group-toggle" data-toggle="buttons"></div>
                        </div>                                     
                    </div>
                    <div class="card-body text-center">
                        <button type="button" class="btn btn-primary btn-lg " v-on:click="generateCurrent()">Ready!</button>
                    </div>
                </div>
            </div>
            <!--_____________________________________________________-->
            <div class="col">

            </div>
        </div>

        <div class="row">
            <div class="col"></div>
            <div class="col-md-6">
                <div class="card bg-light">
                    <div class="card-header bg-dark">HOW TO</div>
                        <div class="card-body">
                            <p>Select however many categories you want to study with and press Ready! Using only one category opens up a couple extra options for ease of use.</p>
                        </div>  
                    </div>
                </div>
            <div class="col"></div>
        </div>
    </div>        
  </div>
</template>

<script>
import Test from "./components/test";
import MyTable from "./components/table";
import Axios from 'axios';
import VueAxios from 'vue-axios';
//import BootstrapVue from 'bootstrap-vue';

export default {
  name: 'App',
  data(){
    return{
        myToggle: false,
        autoFirstLetter: false,
        oneSelected: true,
        showChart: false,
        lastRnd: 0,
        activeColor: 'black',
        title: 'Hello World',
        currentJpnChar: "Choose a category",
        currentEngChar: "",
        userIn: "",
        currentFirstLetter: "",
        characters: [],
        charactersPHP: [[]],
        charactersXML: [],
        charactersJSON: [[]],
        buttonChars: [],
        showButtons: false,
        cboxes: [
            {enabled: true, set: 1}, //k
            {enabled: false, set: 2}, //s
            {enabled: false, set: 3}, //t
            {enabled: false, set: 4}, //n
            {enabled: false, set: 5}, //h
            {enabled: false, set: 6},  //m
            {enabled: false, set: 7},  //y
            {enabled: false, set: 8},  //r
            {enabled: false, set: 9}, //w
            {enabled: false, set: 10},  //vow
            {enabled: false, set: 11}, //k
            {enabled: false, set: 12}, //s
            {enabled: false, set: 13}, //t
            {enabled: false, set: 14}, //n
            {enabled: false, set: 15}, //h
            {enabled: false, set: 16},  //m
            {enabled: false, set: 17},  //y
            {enabled: false, set: 18},  //r
            {enabled: false, set: 19}, //w
            {enabled: false, set: 20}  //vow

        ]

    }
  }, //end data()
  methods: {
            enterHit: function(){
                //validate
                //app.getCharacters();
                console.log(this.userIn);
                console.log(this.currentFirstLetter);
                console.log(this.currentFirstLetter + this.userIn);
                console.log(this.currentEngChar);
                if(!this.autoFirstLetter)
                {
                    this.currentFirstLetter = "";
                }

                if((this.currentFirstLetter + this.userIn).toUpperCase() == this.currentEngChar.toUpperCase())
                {
                    this.newCharacter();
                    this.userIn = "";
                }
                else
                {
                    this.activeColor = "red";
                    this.userIn = "";
                }
                this.$refs.testo.focus(); //puts focus back on tbox in case user used button to advance
            },
            getCharacters: function(){
                var app = this; //this stores a version of 'this' as opposed to using a current 'this' | http://localhost/myapp/server/test.php | https://studentwebfilesus.ipage.com/cmeier/myappy/test.php
                // Axios.get("https://studentwebfilesus.ipage.com/cmeier/myappy/test.php").then(
                //         function(response){
                //         app.charactersPHP = response.data; 
                //         app.newCharacter();                       
                //     }
                // );
                
            },
            newCharacter: function(){
                this.activeColor = "black";
                
                var i = Math.floor(Math.random() * this.characters.length);
                if(i == this.lastRnd)
                {
                    if(i == (this.characters.length-1)) //if last index
                    {
                        i--;
                    }
                    else
                    {
                        i++;
                    }
                }

                this.currentEngChar = this.characters[i]["Eng"];
                this.currentJpnChar = this.characters[i]["Jpn"];
                this.currentFirstLetter = this.characters[i]["FirstLetter"];
                this.lastRnd = i;
                //this.autoButtons();
            },
            generateCurrent: function() //Ready! button
            {
                this.characters = [];
                var countSelected = 0;

                for(var i = 0; i < this.cboxes.length; i++) //loop through all the Category cboxes
                {
                    if(this.cboxes[i].enabled) //if a category is active
                    {
                        countSelected++;
                        for(var x = 0; x < this.charactersPHP.length; x++)// foreach char in charactersPHP where set = cboxes[i].set
                        {
                            if(this.charactersPHP[x]["Set"] == this.cboxes[i].set)
                            {
                                this.characters.push(this.charactersPHP[x]);
                            }
                        }
                    }
                }
                if(countSelected == 1)
                {
                    this.oneSelected = true;
                }
                else
                {
                    this.oneSelected = false;
                    this.currentFirstLetter = "";
                    this.autoFirstLetter = false;
                }
                this.buttonChars = [];

                if(this.oneSelected)
                {
                    for(var x = 0; x < this.characters.length; x++)
                    {                    
                        this.buttonChars.push(this.characters[x]["Eng"])
                    }
                }
                else
                {

                }
                console.log(this.characters);
                this.newCharacter();
            },

            autoButtons: function(btn) //create a set of at most 5 buttons
            {
                this.userIn = btn;
                this.enterHit();
            },
            getCharactersJSON: function(){
                this.charactersJSON = JSON.parse('{"type":"table","name":"charactermap","database":"flashcard","data":[{"ID":"1","Eng":"ka","Jpn":"か","Set":"1","FirstLetter":"k"},{"ID":"2","Eng":"ki","Jpn":"き","Set":"1","FirstLetter":"k"},{"ID":"3","Eng":"ku","Jpn":"く","Set":"1","FirstLetter":"k"},{"ID":"4","Eng":"ke","Jpn":"け","Set":"1","FirstLetter":"k"},{"ID":"5","Eng":"ko","Jpn":"こ","Set":"1","FirstLetter":"k"},{"ID":"6","Eng":"sa","Jpn":"さ","Set":"2","FirstLetter":"s"},{"ID":"7","Eng":"shi","Jpn":"し","Set":"2","FirstLetter":"sh"},{"ID":"8","Eng":"su","Jpn":"す","Set":"2","FirstLetter":"s"},{"ID":"9","Eng":"se","Jpn":"せ","Set":"2","FirstLetter":"s"},{"ID":"10","Eng":"so","Jpn":"そ","Set":"2","FirstLetter":"s"},{"ID":"11","Eng":"ta","Jpn":"た","Set":"3","FirstLetter":"t"},{"ID":"12","Eng":"chi","Jpn":"ち","Set":"3","FirstLetter":"ch"},{"ID":"13","Eng":"tsu","Jpn":"つ","Set":"3","FirstLetter":"ts"},{"ID":"14","Eng":"te","Jpn":"て","Set":"3","FirstLetter":"t"},{"ID":"15","Eng":"to","Jpn":"と","Set":"3","FirstLetter":"t"},{"ID":"16","Eng":"na","Jpn":"な","Set":"4","FirstLetter":"n"},{"ID":"17","Eng":"ni","Jpn":"に","Set":"4","FirstLetter":"n"},{"ID":"18","Eng":"nu","Jpn":"ぬ","Set":"4","FirstLetter":"n"},{"ID":"19","Eng":"ne","Jpn":"ね","Set":"4","FirstLetter":"n"},{"ID":"20","Eng":"no","Jpn":"の","Set":"4","FirstLetter":"n"},{"ID":"21","Eng":"ha","Jpn":"は","Set":"5","FirstLetter":"h"},{"ID":"22","Eng":"hi","Jpn":"ひ","Set":"5","FirstLetter":"h"},{"ID":"23","Eng":"fu","Jpn":"ふ","Set":"5","FirstLetter":"f"},{"ID":"24","Eng":"he","Jpn":"へ","Set":"5","FirstLetter":"h"},{"ID":"25","Eng":"ho","Jpn":"ほ","Set":"5","FirstLetter":"h"},{"ID":"26","Eng":"ma","Jpn":"ま","Set":"6","FirstLetter":"m"},{"ID":"27","Eng":"mi","Jpn":"み","Set":"6","FirstLetter":"m"},{"ID":"28","Eng":"mu","Jpn":"む","Set":"6","FirstLetter":"m"},{"ID":"29","Eng":"me","Jpn":"め","Set":"6","FirstLetter":"m"},{"ID":"30","Eng":"mo","Jpn":"も","Set":"6","FirstLetter":"m"},{"ID":"31","Eng":"ya","Jpn":"や","Set":"7","FirstLetter":"y"},{"ID":"32","Eng":"yu","Jpn":"ゆ","Set":"7","FirstLetter":"y"},{"ID":"33","Eng":"yo","Jpn":"よ","Set":"7","FirstLetter":"y"},{"ID":"34","Eng":"ra","Jpn":"ら","Set":"8","FirstLetter":"r"},{"ID":"35","Eng":"ri","Jpn":"り","Set":"8","FirstLetter":"r"},{"ID":"36","Eng":"ru","Jpn":"る","Set":"8","FirstLetter":"r"},{"ID":"37","Eng":"re","Jpn":"れ","Set":"8","FirstLetter":"r"},{"ID":"38","Eng":"ro","Jpn":"ろ","Set":"8","FirstLetter":"r"},{"ID":"39","Eng":"wa","Jpn":"わ","Set":"9","FirstLetter":"w"},{"ID":"42","Eng":"wo","Jpn":"を","Set":"9","FirstLetter":"w"},{"ID":"43","Eng":"a","Jpn":"あ","Set":"10","FirstLetter":""},{"ID":"44","Eng":"i","Jpn":"い","Set":"10","FirstLetter":""},{"ID":"45","Eng":"u","Jpn":"う","Set":"10","FirstLetter":""},{"ID":"46","Eng":"e","Jpn":"え","Set":"10","FirstLetter":""},{"ID":"47","Eng":"o","Jpn":"お","Set":"10","FirstLetter":""},{"ID":"48","Eng":"ka","Jpn":"カ","Set":"11","FirstLetter":"k"},{"ID":"49","Eng":"ki","Jpn":"キ","Set":"11","FirstLetter":"k"},{"ID":"50","Eng":"ku","Jpn":"ク","Set":"11","FirstLetter":"k"},{"ID":"51","Eng":"ke","Jpn":"ケ","Set":"11","FirstLetter":"k"},{"ID":"52","Eng":"ko","Jpn":"コ","Set":"11","FirstLetter":"k"},{"ID":"53","Eng":"sa","Jpn":"サ","Set":"12","FirstLetter":"s"},{"ID":"54","Eng":"shi","Jpn":"シ","Set":"12","FirstLetter":"sh"},{"ID":"55","Eng":"su","Jpn":"ス","Set":"12","FirstLetter":"s"},{"ID":"56","Eng":"se","Jpn":"セ","Set":"12","FirstLetter":"s"},{"ID":"57","Eng":"so","Jpn":"ソ","Set":"12","FirstLetter":"s"},{"ID":"58","Eng":"ta","Jpn":"タ","Set":"13","FirstLetter":"t"},{"ID":"59","Eng":"chi","Jpn":"チ","Set":"13","FirstLetter":"ch"},{"ID":"60","Eng":"tsu","Jpn":"ツ","Set":"13","FirstLetter":"ts"},{"ID":"61","Eng":"te","Jpn":"テ","Set":"13","FirstLetter":"t"},{"ID":"62","Eng":"to","Jpn":"ト","Set":"13","FirstLetter":"t"},{"ID":"63","Eng":"na","Jpn":"ナ","Set":"14","FirstLetter":"n"},{"ID":"64","Eng":"ni","Jpn":"ニ","Set":"14","FirstLetter":"n"},{"ID":"65","Eng":"nu","Jpn":"ヌ","Set":"14","FirstLetter":"n"},{"ID":"66","Eng":"ne","Jpn":"ネ","Set":"14","FirstLetter":"n"},{"ID":"67","Eng":"no","Jpn":"ノ","Set":"14","FirstLetter":"n"},{"ID":"68","Eng":"ha","Jpn":"ハ","Set":"15","FirstLetter":"h"},{"ID":"69","Eng":"hi","Jpn":"ヒ","Set":"15","FirstLetter":"h"},{"ID":"70","Eng":"fu","Jpn":"フ","Set":"15","FirstLetter":"f"},{"ID":"71","Eng":"he","Jpn":"ヘ","Set":"15","FirstLetter":"h"},{"ID":"72","Eng":"ho","Jpn":"ホ","Set":"15","FirstLetter":"h"},{"ID":"73","Eng":"ma","Jpn":"マ","Set":"16","FirstLetter":"m"},{"ID":"74","Eng":"mi","Jpn":"ミ","Set":"16","FirstLetter":"m"},{"ID":"75","Eng":"mu","Jpn":"ム","Set":"16","FirstLetter":"m"},{"ID":"76","Eng":"me","Jpn":"メ","Set":"16","FirstLetter":"m"},{"ID":"77","Eng":"mo","Jpn":"モ","Set":"16","FirstLetter":"m"},{"ID":"78","Eng":"ya","Jpn":"ヤ","Set":"17","FirstLetter":"y"},{"ID":"79","Eng":"yu","Jpn":"ユ","Set":"17","FirstLetter":"y"},{"ID":"80","Eng":"yo","Jpn":"ヨ","Set":"17","FirstLetter":"y"},{"ID":"81","Eng":"ra","Jpn":"ラ","Set":"18","FirstLetter":"r"},{"ID":"82","Eng":"ri","Jpn":"リ","Set":"18","FirstLetter":"r"},{"ID":"83","Eng":"ru","Jpn":"ル","Set":"18","FirstLetter":"r"},{"ID":"84","Eng":"re","Jpn":"レ","Set":"18","FirstLetter":"r"},{"ID":"85","Eng":"ro","Jpn":"ロ","Set":"18","FirstLetter":"r"},{"ID":"86","Eng":"wa","Jpn":"ワ","Set":"19","FirstLetter":"w"},{"ID":"87","Eng":"wo","Jpn":"ヲ","Set":"19","FirstLetter":"w"},{"ID":"88","Eng":"a","Jpn":"ア","Set":"20","FirstLetter":""},{"ID":"89","Eng":"i","Jpn":"イ","Set":"20","FirstLetter":""},{"ID":"90","Eng":"u","Jpn":"ウ","Set":"20","FirstLetter":""},{"ID":"91","Eng":"e","Jpn":"エ","Set":"20","FirstLetter":""},{"ID":"92","Eng":"o","Jpn":"オ","Set":"20","FirstLetter":""},{"ID":"92","Eng":"n","Jpn":"ン","Set":"20","FirstLetter":""}]}');
                this.charactersPHP = this.charactersJSON.data;
                console.log(this.charactersPHP.data);
                //this.newCharacter();
            }
  }, //end methods
  components: {
    MyTable
  },
  created: function(){
      //this.getCharacters();
      this.getCharactersJSON();
  }


} //end export
</script>

<style lang="scss"> //after building, I cut and pasted the top :root line in the .css underneath the bottom :root line. might be imported twice somehow
$theme-colors:(
    //"primary": #bd2d2d,
    //"light": #ffeaea,
    //"dark": #ffcece
);

//$enable-shadows: true;


@import "node_modules/bootstrap/scss/bootstrap";
</style>

<style>
#app{
    font-family: 'Poiret One'; /*Poiret One, Amaranth, Jura*/
    font-size: 26px;
}
/* .packInside{
    height: 500px;
    overflow-y: scroll;
} */
.autoBtn{
    min-width: 60px !important;
    max-width: 70px !important;
}

</style>




// WEBPACK FOOTER //
// src/App.vue